/**
 * Interval in milliseconds between polling of resources.
 *
 * @see Usage in {@link tmrResourcePolling}
 *
 * @namespace tmrResourcePollingInterval
 * @type {ngConstant}
 */
export const constant = ['tmrResourcePollingInterval', 5000]
